export default "__VITE_ASSET__b1b53654__"